import {
    getPerPageOptions,
    onTooltipShow, getDate
} from '@shared/components/admin/pages/Management/common-data';

export default function PaginationPageMixin({searchForm = {}, pagination = {}}) {
    return {
        data() {
            return {
                listLoading: false,
                searchResults: null,
                searchFormValue: JSON.parse(JSON.stringify(searchForm)),
                pagination: pagination,
                perPageOptions: getPerPageOptions()
            };
        },
        computed: {
            get_tooltip_title() {
                return (data) => {
                    return data ? {title: data} : null;
                };
            },
            get_date() {
                return (date) => {
                    return getDate(date);
                };
            }
        },
        mounted() {
            this.$root.$on('bv::tooltip::show', this.onTooltipShow);
        },
        beforeDestroy() {
            this.$root.$off('bv::tooltip::show', this.onTooltipShow);
        },
        methods: {
            onTooltipShow,
            setSearchDataFormQuery() {
                Object.keys(this.searchFormValue).forEach(key => {
                    if (this.$route.query[key] !== undefined) {
                        this.searchFormValue[key] = this.$route.query[key];
                    } else {
                        this.searchFormValue[key] = null;
                    }
                });
                
                if (this.pagination != null) {
                    this.pagination.currentPage = Number(this.$route.query.current_page) || 1;
                    this.pagination.perPage = Number(this.$route.query.per_page) || 20;
                }
            },
            async changeQuery({page, pageSize}) {
                const query = {
                    ...this.$route.query,
                };
                let checkSameQuery = true;
                
                
                const toQueryObj = {
                    ...this.searchFormValue,
                };
                if (this.pagination != null) {
                    toQueryObj.current_page = page ?? this.pagination.currentPage;
                    toQueryObj.per_page = pageSize ?? this.pagination.perPage;
                }
                
                Object.entries(toQueryObj).forEach(([key, item]) => {
                    if (query[key] != toQueryObj[key]) {
                        checkSameQuery = false;
                        query[key] = toQueryObj[key];
                    }
                });
                
                if (!checkSameQuery) {
                    await this.$router.push({query}).catch(e => {
                    });
                }
                return checkSameQuery;
            },
            resetForm() {
                this.searchFormValue = JSON.parse(JSON.stringify(searchForm));
                if (this.pagination != null) {
                    this.pagination.currentPage = 1;
                }
            },
        },
    };
}
